import { Form, Select } from 'antd';
import React, { memo } from 'react';
import useCountries from '../../../../queries/useCountries';

const CountrySelect = ({ editingCounterparty, getFieldDecorator,className }) => {
  const { data: countries, isFetching: countriesLoading } = useCountries();
  return (
    <Form.Item label="Страна" className={className}>
      {getFieldDecorator('country', {
        initialValue: editingCounterparty?.country
          ? {
              key: editingCounterparty.country.id,
              label: editingCounterparty.country.name,
            }
          : undefined,
      })(
        <Select
          labelInValue
          placeholder={'Выберите из списка'}
          loading={countriesLoading}
        >
          {countries?.map((country) => (
            <Select.Option key={country.id}>
              {country.name}
            </Select.Option>
          ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default CountrySelect;
